import React, { useState } from 'react';
import tw from 'twin.macro';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';

interface Props {
  landscape?: boolean;
  iframeUrl: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  withInnerMargin?: boolean;
  onePage?: boolean;
}

export function IframePreviewPDF(props: Props) {
  const { landscape, iframeRef, iframeUrl, withInnerMargin, onePage } = props;
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div
      css={[
        tw`p-6`,
        // magic values... en tout cas ça marche
        // d'après mes tests ça colle parfaitement avec le PDF
        landscape ? tw`w-[312mm]` : tw`w-[223mm]`,
        !onePage && tw`h-full`,
        onePage && landscape && tw`h-[223mm]`,
        onePage && !landscape && tw`h-[312mm]`,
      ]}
    >
      <div
        css={[
          tw`bg-white rounded-lg shadow-lg h-full`,
          withInnerMargin && tw`p-3`,
        ]}
      >
        {isLoading && <SpinnerComponent />}
        <iframe
          id="printFrame"
          ref={iframeRef}
          src={iframeUrl}
          css={[tw`w-full h-full block`, isLoading && tw`hidden`]}
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
}
